
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M88.4 203c0 .1 0 .1 0 0 .2 19.4 11.2 36.2 27.4 44.5v174c0 4.1 3.4 7.5 7.5 7.5h265.4c4.1 0 7.5-3.4 7.5-7.5v-174c16.1-8.4 27.2-25.2 27.4-44.5v-.4-.1-.5-.3c0-.1 0-.3-.1-.4 0-.1 0-.2-.1-.4 0-.1-.1-.2-.1-.3 0-.1-.1-.3-.1-.4 0-.1-.1-.2-.1-.3-.1-.2-.1-.3-.2-.4v-.1L391 131.8v-25.7c0-12.8-10.4-23.3-23.3-23.3H144c-12.8 0-23.3 10.4-23.3 23.3v26.3l-31.6 67v.1c-.1.1-.1.3-.2.4 0 .1-.1.2-.1.3 0 .1-.1.3-.1.4 0 .1-.1.2-.1.3 0 .1 0 .2-.1.4 0 .1 0 .3-.1.4v1.3zm44.9-62h55.5l-12.5 54.1h-68.6l25.6-54.1zm174.5 0l12.5 54.1h-56.8V141h44.3zm96.4 54.1h-68.6L323.2 141h55.5l25.5 54.1zm-78.2 25c-6.3 11.1-18.2 18.2-31.1 18.2-13.2 0-25.3-7.4-31.5-19v-9.1h60.2l2.4 9.9zm-137.7-10h60.2v9.1c-6.1 11.6-18.3 19-31.5 19-12.9 0-24.8-7.1-31.1-18.2l2.4-9.9zm60.2-15h-56.8l12.5-54.1h44.3v54.1zm-144.3 15h68.6l-1.9 8.4c-6 12-18.4 19.8-31.9 19.8-17 0-31.3-12.1-34.8-28.2zm188.7 204v-72.9c0-.9.7-1.6 1.6-1.6h42.3c.9 0 1.6.7 1.6 1.6v72.9h-45.5zm88.3 0h-27.9v-72.9c0-9.1-7.4-16.6-16.6-16.6h-42.3c-9.1 0-16.6 7.4-16.6 16.6v72.9h-147V252.6c2.7.4 5.4.7 8.3.7 15.2 0 29.5-6.9 39-18.4 9.5 11.4 23.8 18.4 39 18.4s29.5-6.9 39-18.4c9.5 11.4 23.8 18.4 39 18.4s29.5-6.9 39-18.4c9.5 11.4 23.8 18.4 39 18.4 2.8 0 5.6-.2 8.3-.7v161.5zm-8.3-175.8c-13.5 0-25.9-7.7-31.9-19.8l-1.9-8.4h68.6c-3.4 16.1-17.7 28.2-34.8 28.2zM135.8 106.2c0-4.5 3.7-8.3 8.3-8.3h223.7c4.5 0 8.3 3.7 8.3 8.3V126H135.8v-19.8z"}}),_c('path',{attrs:{"d":"M237.8 272.6h-81.3c-4.1 0-7.5 3.4-7.5 7.5v65c0 4.1 3.4 7.5 7.5 7.5h81.3c4.1 0 7.5-3.4 7.5-7.5v-65c0-4.2-3.4-7.5-7.5-7.5zm-7.5 32.5h-25.7v-17.5h25.7v17.5zm-40.7-17.5v17.5H164v-17.5h25.6zM164 320.1h25.7v17.5H164v-17.5zm40.6 17.5v-17.5h25.7v17.5h-25.7z"}})])
          )
        }
      }
    